var FuseDirectivesModule = /** @class */ (function () {
    function FuseDirectivesModule() {
    }
    return FuseDirectivesModule;
}());
export { FuseDirectivesModule };
